import { jsxs, jsx } from 'react/jsx-runtime';
import { cloneElement } from 'react';
import { InfoCircle } from '@zooplus/icons';

const FormMessages = ({ infoMessage, errorMessage, infoMessageIcon, errorMessageIcon, errorZta, }) => {
    const infoClassName = 'z-form-message__icon';
    const errorClassName = 'z-form-message__icon z-form-message__icon--error';
    return (jsxs("div", { children: [infoMessage && (jsxs("div", { className: "z-form-message", children: [jsx("i", { className: "z-form-message__icon-wrap", children: infoMessageIcon ? (cloneElement(infoMessageIcon, {
                            className: infoClassName,
                        })) : (jsx(InfoCircle, { className: infoClassName })) }), jsx("div", { className: "z-form-message__text", children: infoMessage })] })), errorMessage && (jsxs("div", { className: "z-form-message", children: [jsx("i", { className: "z-form-message__icon-wrap", children: errorMessageIcon ? (cloneElement(errorMessageIcon, {
                            className: errorClassName,
                        })) : (jsx(InfoCircle, { className: errorClassName })) }), jsx("div", { "data-zta": errorZta, className: "z-form-message__text", children: errorMessage })] }))] }));
};

export { FormMessages as default };
//# sourceMappingURL=FormMessages.js.map
